export default __webpack_public_path__ + "static/pattern2-f7299d6c5a52ad989f54600ea6917de0.png";